import { Menu,Layout,message} from "antd"
import { useCallback, useEffect, useRef, useState } from "react";
import CenterData from "./CenterData.jsx";
import "./CenterDetail.css" 
import {useParams,useLocation} from "react-router-dom";
import CenterService from "./../../../services/CenterService"
import CenterCoordinator from "./CenterCoordinator";
import CenterListInvestigators from "./CenterListInvestigators.jsx";
import CenterListProyects  from "./CenterListProyects.jsx";
import CenterInformation from "./CenterInformation.jsx";
import CenterStadistics from "./CenterStadistics.jsx"
import PermissionCenter from "../Permission Letter/PermissionCenter.jsx";

import ImagePerfil from "../../../Assets/ImagePerfil.jpg"
import LogoUcatolica from "../../../Assets/LogoUcatolica.jpg"

const {SubMenu}=Menu;
const {Content, Sider } = Layout;
  
export default function CenterDetail() {
    const params=useParams();
    const centerId=params.id;
    const [selectedMenuItem,setSelectedMenuItem]=useState("dataCenter")
    const [center,setCenter]=useState([]);  
    const [updateCenterLogo,setUpdateCenterLogo]=useState(false);  
    const [centerLogo,setCenterLogo]=useState({
        id:"",
        logoCenter: "",
    });  
    const { current: query } = useRef(new URLSearchParams(useLocation().search));

    const imagePerfil=ImagePerfil;
    // const imageBackground="https://upload.wikimedia.org/wikipedia/commons/1/1f/Ucatolica2.jpg";
    //const imagePerfil="https://i.pinimg.com/originals/49/c8/e4/49c8e403cd1929e9e7b02126824ff831.jpg";
    
    const getCenter=useCallback(()=>{
        CenterService.getCenterById(centerId).then((res)=>{
            // console.log("response",res)
            let {response,success}=res.data
            if(success){
                setCenter(response)
            }
            else{
                message.error("no se pudo obtener la información del centro")
            }
        })
    },[]);

    const getLogoByCenter=useCallback((centerID)=>{
        CenterService.getLogoByCenter(centerID).then((res)=>{
            let {response,success}=res.data
            if(success){
                response.logoCenter!=null?
                    setCenterLogo(response): setCenterLogo({
                        id:centerID,
                        logoCenter:null,
                    })            
            }
            else{
                message.error("No se pudo obtener el logo del centro")
            }
            setUpdateCenterLogo(false)
        })
    },[]);

    const updateLogoByCenter=(value)=>{
        setUpdateCenterLogo(value)
    }

    useEffect(()=>{
        if(query.get("option")!==null){
            console.log(query.get("option"))
            setSelectedMenuItem(query.get("option"))
        }
        getCenter();
        getLogoByCenter(centerId)
    },[getCenter,getLogoByCenter,query,centerId])


    useEffect(()=>{
        getLogoByCenter(centerId)
    },[updateCenterLogo,getLogoByCenter])


    const switChOptionsMenu=(key)=>{
        switch(key){
            case "dataCenter":
                return <CenterData 
                Body={center} 
                updateLogoByCenter={updateLogoByCenter} 
                CenterLogo={centerLogo}
                defaultLogo={LogoUcatolica}
                />
            case"dataCoordinator":  
                return <CenterCoordinator 
                Body={center} 
                CenterLogo={centerLogo}
                DefaultLogo={LogoUcatolica}
                DefaultProfile={imagePerfil}
                />
            case"dataMisionAndVision":
                return <CenterInformation body={center}/>
            case"listInvestigators":
                return <CenterListInvestigators body={center}/>

            case"listProjects":
            return <CenterListProyects body={center} />

            case"dataStadistic":
                return <CenterStadistics body={center}/>

            case"PermissionLetter":
                return <PermissionCenter Center={center}/>


        }
    }

    return(
    <>
    <Layout style={{margin:30, gap:15}} >
        <Sider 
        breakpoint="lg"
        style={{backgroundColor:"transparent"}}
        >
            <Menu 
            mode="inline"
            onClick={(e)=>{setSelectedMenuItem(e.key)}}
            selectedKeys={[selectedMenuItem]}
            defaultOpenKeys={["List"]}
            className="ContainerOfMenuOptions">   
                            <Menu.Item key={"dataCenter"}>
                                    Datos generales
                                </Menu.Item>
                                <Menu.Item key={"dataCoordinator"}>
                                    Coordinador encargado
                                </Menu.Item>
                                <Menu.Item key={"dataMisionAndVision"}>
                                    Objetivos del centro
                                </Menu.Item>
                                <Menu.Item key={"PermissionLetter"}>
                                    Carta de permiso de funcionamiento
                                </Menu.Item>
                                <SubMenu
                                title="Lista"
                                key={"List"}
                                >
                                    <Menu.Item key={"listInvestigators"}> 
                                        Investigadores
                                    </Menu.Item>
                                    <Menu.Item key={"listProjects"}> 
                                        Proyectos
                                    </Menu.Item>
                                </SubMenu>
                            </Menu>
        </Sider>
            <Layout>
            <Content className="ContainerOfMenuOptions">
                    {switChOptionsMenu(selectedMenuItem)}
            </Content>
            </Layout>
    </Layout>
    </>
    )   
}